<template>
  <KTPortlet :hideBody="!showSearch" :hideFoot="!showSearch">
    <template v-slot:title>
      <v-select
        @change="dateSelected"
        item-text="value"
        solo
        :items="dateOptions"
        v-model="selectedDate"
        dense
      ></v-select>

      <v-select
        v-model="status"
        :items="currentStatuses"
        placeholder="Status"
        multiple
        clearable
        small-chips
        solo
        chips
        deletable-chips
        dense
      ></v-select>
    </template>
    <template v-slot:toolbar>
      <b-button type="button" @click="toggleDisplay">
        <i class="fa-solid fa-magnifying-glass"></i>
      </b-button>
    </template>
    <template v-slot:body>
      <b-row align-h="center" align-v="center">
        <b-col sm="5">
          <b-row>
            <b-col>
              <DateRange
                @change="onDateRangeChange"
                v-model="localValue.dateRange"
            /></b-col>
          </b-row>
          <b-row
            ><b-col>
              <MultiSelect
                v-model="localValue.transactionStatus"
                fieldName="transactionStatus"
                label="Status Search"
                :options="transactionStatusOptions"
                :multiple="false"/></b-col
          ></b-row>
        </b-col>
        <b-col
          sm="2"
          align-self="stretch"
          class="d-flex justify-content-center"
        >
          <v-divider class="mx-4" light vertical></v-divider>
        </b-col>
        <b-col sm="5">
          <b-form-group label="Order Number Search" label-for="orderNumber">
            <b-form-input
              id="orderNumber"
              type="text"
              v-model.trim="localValue.orderNumber"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <slot name="additionalFields"></slot>
    </template>
    <template v-slot:foot>
      <div class="d-flex justify-content-between">
        <b-button type="button" @click="reset()" variant="primary"
          >Reset</b-button
        >
        <b-button type="button" @click="search()" variant="danger"
          >Search</b-button
        >
      </div>
    </template>
  </KTPortlet>
</template>
<style scoped>
.fa-magnifying-glass {
  padding: 0;
  color: rgb(135, 135, 135);
  font-size: 1.3rem;
}
.v-select {
  margin-top: 1.5rem;
  margin-right: 1rem;
}
.select button {
  margin-left: 1rem;
}
</style>
<script>
import KTPortlet from "@/views/partials/content/Portlet";
import DateRange from "@/components/form-elements/search-components/DateRange.vue";
import MultiSelect from "@/components/form-elements/search-components/MultiSelect.vue";

export default {
  components: {
    KTPortlet,
    DateRange,
    MultiSelect
  },
  props: {
    title: {
      type: String,
      required: false,
      default: "Search"
    },
    value: {
      required: true
    },
    statusOptions: {
      type: Array,
      required: true,
      default() {
        return [];
      }
    },
    currentStatuses: { type: Array },
    showSearchInitially: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      showSearch: false,
      status: [],
      selectedDate: "Past 14 days",
      dateOptions: [
        { value: "Past 90 days" },
        { value: "Past 30 days" },
        { value: "Past 14 days" },
        { value: "Past 7 days" }
      ]
    };
  },
  watch: {
    localValue: {
      handler(newVal) {
        this.$emit("input", newVal);
      },
      deep: true
    },

    status(value) {
      this.$emit("filterSelectedStatus", value);
    }
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      }
    },

    transactionStatusOptions() {
      let searchOptions = [{ value: "any", text: "Any" }];
      searchOptions = searchOptions.concat(this.statusOptions);
      return searchOptions;
    },
    toggleDisplayButtonText() {
      return this.showSearch ? "Hide" : "Show";
    }
  },
  methods: {
    onDateRangeChange() {
      this.selectedDate = "Custom";
    },
    dateSelected(val) {
      let to = new Date();
      this.addDays(to, 1);
      let from = new Date();

      switch (val) {
        case "Past 90 days":
          this.addDays(from, -90);
          break;
        case "Past 30 days":
          this.addDays(from, -30);
          break;
        case "Past 14 days":
          this.addDays(from, -14);
          break;
        case "Past 7 days":
          this.addDays(from, -7);
          break;
        case "Custom":
          return;
        default:
          this.addDays(from, -14);
      }

      this.localValue.dateRange.to = to;
      this.localValue.dateRange.from = from;

      this.search();
    },
    addDays(date, period) {
      date.setDate(date.getDate() + period);
    },
    toggleDisplay() {
      this.showSearch = !this.showSearch;
    },
    search() {
      this.$emit("search");
    },
    reset() {
      this.$emit("reset");
    }
  },
  created() {
    this.showSearch = this.showSearchInitially;
  }
};
</script>

<style lang="scss" scoped></style>
